import textServices from 'services/text-services'
import ErrorView from 'components/error-view'
import useMainClass, { usePopupContext } from 'hooks/use-main-cass'
import { useHistory, useLocation } from 'react-router-dom'
import { AxiosError } from 'axios'

interface IProps {
  errorCode: AxiosError
}

const PopUpError = ({ errorCode }: IProps) => {
  const { closePopup } = usePopupContext()
  useMainClass('trivia__pop-up__error')
  const location = useLocation()

  const history = useHistory()
  console.log('location', location.pathname)
  const onRetry = async () => {
    if (location.pathname !== '/') history.push(textServices.findByText(`error/${errorCode}/button/link`, '/'))
    closePopup()
  }

  const buttonMenu = () => {
    if (location.pathname !== '/') history.push(textServices.findByText(`error/${errorCode}/button/link`, '/'))
    closePopup()
  }

  if (errorCode) {
    return <ErrorView code={Number(errorCode) ?? 9999} buttonMenu={buttonMenu} onRetry={onRetry} />
  }

  return null
}

export default PopUpError
